<template>
  <v-row justify="center">
          <v-col cols="12" md="8" lg="4">
            <v-card class="elevation-12">
              <v-card-title class="primary">
                <span class="headline white--text">Iniciar sesión</span>
              </v-card-title>
              <v-card-text>
                <v-form action="/login_user/" method="post">
                  <v-text-field
                    v-model="username"
                    label="Usuario"
                    name="usuario"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    label="Contraseña"
                    type="password"
                    name="password"
                    required
                  ></v-text-field>
                  <v-btn type="submit" color="primary" class="mr-4">Ingresar</v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
</template>

<script>
export default {
  name:"LoginChess",
  data() {
    return {
      username: '',
      password: '',
    };
  },
  methods: {

    login() {
      // Aquí puedes realizar la lógica para autenticar al usuario
      // Por ejemplo, puedes hacer una solicitud a tu API para verificar las credenciales
      // y luego redirigir al usuario a la página de inicio si las credenciales son válidas.
    },
  },
}
</script>

<style>
.primary {
  background-color: #1976d2;
}
</style>